import { usePostHog } from "posthog-js/react";
import { useEffect, useRef } from "react";

/**
 * Fires a PostHog capture exactly once per component mount.
 * Prevents duplicate events from React Query refetches or re-renders.
 *
 * @param event - The event name (e.g., "offers_offer_viewed")
 * @param properties - Event properties (optional)
 * @param options.enabled - When false, defers the capture until it becomes true (default: true)
 */
export function useCaptureOnce(
  event: string,
  properties?: Record<string, unknown>,
  { enabled = true }: { enabled?: boolean } = {}
) {
  const posthog = usePostHog();
  const hasCaptured = useRef(false);

  useEffect(() => {
    if (posthog && !hasCaptured.current && enabled) {
      hasCaptured.current = true;
      posthog.capture(event, properties);
    }
  }, [posthog, enabled]); // eslint-disable-line react-hooks/exhaustive-deps
}
